// utils/currencyFormatter.js

import { getPathVariables } from "../misc";

// Function to format currency
export const formatCurrency = price => {
    const locale = getPathVariables(window.location.pathname)[0];
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: locale === 'en-US' ? 'USD' : 'CAD',
      minimumFractionDigits: 2
    });
    // Normalize negative zero to prevent -$0.00 display
    const roundedPrice = Math.round(price * 100) / 100;
    const normalizedPrice = roundedPrice === 0 ? 0 : price;
    const updatedprice = formatter.format(normalizedPrice);
    return updatedprice;
  };